export default __webpack_public_path__ + "static/experienceImg2-60992243d77576205dc127eeabb658c2.webp";